import { z } from 'zod';
import { AccessModeSchema } from '../user-application-access/user-application-access.schema';

const ObjectIdSchema = z.string().regex(/^[a-f\d]{24}$/i, 'Invalid ObjectId');
const MAX_APPLICATION_IDS = 500;

export const SsoGroupSchema = z.object({
  id: z.string(),
  display: z.string(),
});

export type SsoGroup = z.infer<typeof SsoGroupSchema>;

export const SsoGroupListResponseSchema = z.object({
  items: z.array(SsoGroupSchema),
});

export type SsoGroupListResponse = z.infer<typeof SsoGroupListResponseSchema>;

export const GroupApplicationMappingSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  groupId: z.string(),
  groupName: z.string(),
  provider: z.string(),
  mode: AccessModeSchema,
  applicationIds: z.array(z.string()),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type GroupApplicationMapping = z.infer<
  typeof GroupApplicationMappingSchema
>;

export const GroupApplicationMappingResponseSchema =
  GroupApplicationMappingSchema;

export type GroupApplicationMappingResponse = z.infer<
  typeof GroupApplicationMappingResponseSchema
>;

export const GroupApplicationMappingListResponseSchema = z.object({
  items: z.array(GroupApplicationMappingResponseSchema),
  total: z.number(),
});

export type GroupApplicationMappingListResponse = z.infer<
  typeof GroupApplicationMappingListResponseSchema
>;

export const SetGroupApplicationMappingSchema = z.object({
  groupId: z.string().min(1, 'Group ID is required'),
  groupName: z.string().min(1, 'Group name is required'),
  mode: AccessModeSchema,
  applicationIds: z.array(ObjectIdSchema).max(MAX_APPLICATION_IDS).default([]),
  targetTenantId: z.string().optional(),
});

export type SetGroupApplicationMappingInput = z.infer<
  typeof SetGroupApplicationMappingSchema
>;

export const UpdateGroupApplicationMappingSchema = z.object({
  groupName: z.string().min(1).optional(),
  mode: AccessModeSchema,
  applicationIds: z.array(ObjectIdSchema).max(MAX_APPLICATION_IDS),
  targetTenantId: z.string().optional(),
});

export type UpdateGroupApplicationMappingInput = z.infer<
  typeof UpdateGroupApplicationMappingSchema
>;
